
export class CustomControl{
  value:string = '';
  fileValue: any;
  type:string = '';
  name:string = '';
  groupValueNames:string[] = [];
};
